import { gql, useQuery } from "@apollo/client";
import {
  ViewAuditLogQueryQuery,
  ViewAuditLogQueryQueryVariables,
  AuditLog
} from "../../../../schemaTypes";

export const viewAuditLogQuery = gql`
  query ViewAuditLogQuery($id: String!) {
    viewAuditLog(id: $id) {
      id
      entity
      action
      entityId
      ipAddress
      userAgent
      createdAt
    }
  }
`;

export function useViewAuditLog(id: string) {
  const { data, loading, error } = useQuery<
    ViewAuditLogQueryQuery,
    ViewAuditLogQueryQueryVariables
  >(viewAuditLogQuery, {
    variables: { id },
    skip: !id,
  });

  return {
    auditLog: data?.viewAuditLog as AuditLog | undefined,
    loading,
    error
  };
}
